// extracted by mini-css-extract-plugin
export var projectContentContainer = "project-page-module--project-content-container--3qgX+";